import { ELanguage, EPages, PATHNAME_REGEX } from '@/common'
import { convertValueToNumber, slugify } from './utilities'

export function getLanguageFromUrl(url: string = ''): ELanguage {
    const locationPath = url.slice(url.length - 2, url.length)
    if (locationPath === 'jd') return ELanguage.EN
    // job-posting-preview | xem-truoc-dang-tuyen-viec-lam
    if (url.indexOf('job-posting-preview') >= 0) return ELanguage.EN
    if (url.indexOf('cv-review') >= 0) return ELanguage.EN
    if (url.indexOf('success-apply') >= 0) return ELanguage.EN

    return ELanguage.VI
}

export function getJobIdFromUrl(url: string) {
    const urlSegment = url.split('?')
    const pathname = urlSegment && urlSegment.length > 0 ? urlSegment[0] : url

    const slug = pathname.replace(/-(jv|jd)$/, '').replaceAll('/', '-')
    const slugSegment = slug.split('-')

    const jobId = convertValueToNumber(slugSegment[slugSegment.length - 1])

    return jobId
}

export const buildJobUrl = ({
    alias,
    jobId,
    utm,
    langCode
}: {
    alias: string
    jobId: number
    langCode: ELanguage
    utm?: string
}) => {
    return `${`/${alias}-${jobId}-${langCode === ELanguage.EN ? 'jd' : 'jv'}`}${
        utm ?? ''
    }`
}

export const buildCompanyUrl = ({
    companyId,
    companySlug,
    companyCCPSlug,
    langCode,
    isCCP = false
}: {
    companyId: number
    companySlug?: string
    companyCCPSlug?: string
    langCode: ELanguage
    isCCP?: boolean
}) => {
    const prefix = langCode === ELanguage.EN ? 'companies' : 'nha-tuyen-dung'
    const companyUrl = `/${prefix}/${slugify(companySlug ?? '')}-c${companyId}`

    return isCCP ? `/company/${companyCCPSlug}` : companyUrl
}

export function getPageNameFromUrl(pathName: string = ''): EPages | '' {
    if (PATHNAME_REGEX.test(pathName)) {
        return EPages.JOB_DETAIL
    }
    return ''
}

export function getSearchParam(searchParams: string, key: string) {
    const searchParamString = searchParams.replace('?', '')
    const valueKeyPairRaw = searchParamString.split('&')

    const valueKeyPair = valueKeyPairRaw.map((item) => item.split('='))

    let responseValue = ''
    // Get valueKeyPair that have match key
    valueKeyPair.filter((item) => {
        if (item.length > 0 && item[0] === key) {
            responseValue = item[1] ?? ''
        }
    })

    return responseValue
}

export function getSearchParamFromObject(obj: object) {
    const keys = Object.keys(obj)
    const values = Object.values(obj)
    const returnArray: string[] = []

    for (let i = 0; i < keys.length; i++) {
        const key = keys[i]
        const value = values[i] ?? ''
        returnArray.push(`${key}=${value}`)
    }

    return returnArray.join('&')
}
